import { bigCardFlow } from '@/mocks/news';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function CardFlowSection() {
  return (
    <section id="flow" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto py-12 md:py-16">
          <SectionHeading
            id="flow"
            kicker="大图卡片流"
            title="图文并排的条目流"
            desc="一条配一张图，先看画面再决定要不要展开；黑料网1更新页把同类条目挨着放，翻起来顺。"
            actionHref="#index"
            actionLabel="用索引筛选"
          />

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {bigCardFlow.map((card) => (
              <article
                key={card.id}
                className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <a href="#flow" className="block cursor-pointer">
                  <div className="w-full aspect-[4/3] overflow-hidden">
                    <img
                      src={card.image}
                      alt={`黑料网1更新：${card.title}`}
                      title={`${card.title} - 黑料网1`}
                      className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                    />
                  </div>
                </a>
                <div className="flex flex-col flex-1 p-5">
                  <span className="self-start inline-flex items-center h-6 px-2 rounded bg-accent-100 text-accent-900 text-[11px] font-medium">
                    {card.category}
                  </span>
                  <h5 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors">
                    <a href="#flow" className="cursor-pointer">
                      {card.title}
                    </a>
                  </h5>
                  <p className="mt-2 flex-1 text-sm text-foreground-600 leading-relaxed">
                    {card.excerpt}
                  </p>
                  <div className="mt-4 flex items-center gap-4 pt-3 border-t border-background-200 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-base" aria-hidden="true"></i>
                      {card.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line text-base" aria-hidden="true"></i>
                      {card.comments}
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-foreground-400 group-hover:text-primary-500 transition-colors">
                      展开
                      <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}